module.exports = __webpack_public_path__ + "static/email-2-0f733f88283e80c7b21c9c69d82a855d.jpg";